import { Controller, useFormContext } from 'react-hook-form';
import { Grid } from '@mui/material';
import { CustomerInput } from '../CustomerInput';

interface IGuarantorProps {
  name: string;
}

export const Guarantor = (props: IGuarantorProps) => {
  const { control } = useFormContext();

  return (
    <Grid item xs={12}>
      <Controller
        name={`${props.name}.customer`}
        control={control}
        rules={{ required: 'Customer is required' }}
        render={({ field, fieldState: { error } }) => <CustomerInput {...field} label='Customer' error={!!error} helperText={error?.message} />}
      />
    </Grid>
  );
};
